<template>
    <div class="footer">
        <div class="footer-content">

            <div class="footer-top">
                <img class="footer-img" src="../assets/img/NTFusion_logo.png" alt="">
                <ul>
                    <li>
                        <router-link style="width: 100%" :to="'/article/6'">{{contents[5]}}</router-link>
                    </li>
                    <li>
                        <router-link style="width: 100%" :to="'/article/7'">{{contents[6]}}</router-link>
                    </li>
                    <li>
                        <router-link style="width: 100%" :to="'/article/8'">{{contents[7]}}</router-link>
                    </li>
                    <li>
                        <router-link style="width: 100%" :to="'/article/9'">{{contents[8]}}</router-link>
                    </li>
                    <li>
                        <a href="http://www.ntfusion.com/privacy-policy.html" target="_blank" style="margin-left: 5px;text-wrap: nowrap;">隐私政策</a>
                    </li>
                </ul>

            </div>


            <p class="fcm">{{contents[3]}}</p>
            <!--<p>{{contents[4]}}</p>-->
            <p>文化部网络游戏举报和联系电子邮箱：service@ntfusion.com 纠纷处理方式：联系客服或依《用户协议》约定方式处理</p>
            <p>
                <a href="http://beian.miit.gov.cn/" target="_blank">{{contents[1]}}</a>
                <!--<a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备15003881号-1</a>-->
                <!--<a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备15003881号-2</a>-->
                |
                <!--<a href="wenwangwenfuben.jpg" target="_blank">{{contents[2]}}</a>-->
                <a>{{contents[2]}}</a>
                <br>
                <!--<a href="http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/81bfb8c7d6c443f79ff894ce75c4539a" target="_blank"><img src="../assets/img/wenhuajingying.png" alt="" width="50" height="50"></a>-->
                <!--<a><img src="../assets/img/wenhuajingying.png" alt="" width="50" height="50"></a>-->
            </p>
            <p>{{contents[9]}}</p>
            <p>超进化物语  出版物号：ISBN978-7-7979-8434-8</p>
            <p>超进化物语2 出版物号：ISBN978-7-498-10039-9</p>
        </div>
    </div>
</template>

<script>
    import httpRequest from '../service/http_request';
    const icp = require('../lib/icp');

    export default {
        name: 'router2',
        data () {
            return {
                contents: ''
            }
        },
        created(){
            this.getContent();
        },
        methods: {
            getContent() {
                var self = this;
                httpRequest.request(
                    'post',
                    icp.urls.page_getContents, {
                        params:{
                            page: 1
                        }
                    }, function (res) {
                        self.contents = res;
                    })
            }
        }
    }
</script>
<style lang="less">
    .footer {
        width: auto;
        padding: 40px 0;
        font-size: 13px;
        color: #ffffff;
        background-color: #282f3e;
        .footer-content {
            margin: 0 auto;
            width: 1000px;
            position: relative;

            .footer-top {
                overflow: unset!important;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;

                .footer-img {
                    width: 150px;
                    height: 50px;
                }
            }

            .fcm:before {
                display: block;
                margin: 18px 0 16px;
                height: 1px;
                content: "";
                background-color: rgba(83,97,128,.9);
            }

            ul {
                display: inline-block;
                li {
                    display: inline-block;
                    width: 60px;
                    height: 15px;
                    line-height: 15px;
                    a {
                        color: #0089bc;
                        text-decoration: underline;
                    }
                }
                li + li {
                    /*border-left: 2px solid #ffffff;*/
                }
            }
            p {
                margin: 10px 0 20px;

                a {
                    color: #ffffff;
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue